import ApiValidationError from '../../models/classes/ApiValidationError';
import ServiceError from '../../models/classes/ServiceError';
import { CartUpdateContract } from '../../types/Cart';
import {
  IOrderService,
  OrderServicePostOrderResponse,
} from '../../types/Order';
import { OrderServiceConfig } from '../../types/ServiceConfigurations';
import { SpreedlyPostOrderResponse } from '../../types/Spreedly';

const InvalidCartIdError = new ServiceError('OrderService', 'invalid CartId');
const ApiError = new ServiceError('OrderService', 'error contacting API');
const OrderFailedError = new ServiceError('OrderService', 'order failed');

class OrderService implements IOrderService {
  private storeUrl: string;

  constructor(config: OrderServiceConfig) {
    this.storeUrl = config.apiUrl;
  }

  public async postOrderDataAsync(
    cartId: string | null,
    cart: CartUpdateContract
  ): Promise<OrderServicePostOrderResponse> {
    if (!cartId) {
      throw InvalidCartIdError;
    }
    try {
      const response = await window.fetch(
        `${this.storeUrl}/api/v1/orders/${cartId ?? ''}`,
        {
          credentials: 'include',
          method: 'POST',
          headers: {
            vMethod: 'POST',
            Accept: 'application/json',
            Connection: 'keep-alive',
            'Content-Type': 'application/json',
            'Keep-Alive': 'timeout=120, max=1000',
          },
          body: JSON.stringify(cart),
        }
      );
      const responseJsonEnvelope = await response.json();
      if (responseJsonEnvelope?.errors?.length) {
        // POSSIBLE FRICTION LOGGING HERE
        throw new ApiValidationError(
          'Order validation failed',
          responseJsonEnvelope.errors
        );
      }

      if (responseJsonEnvelope?.data?.id) {
        return {
          orderId: responseJsonEnvelope.data.id,
          requiresAction: responseJsonEnvelope.data.requiresAction,
          transactionToken: responseJsonEnvelope.data?.transactionToken,
        };
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      if (error?.isValidationError) {
        throw error;
      }
      // eslint-disable-next-line no-console
      console.error(error);
      throw ApiError;
    }
    throw OrderFailedError;
  }

  public async spreedlyPostOrderDataAsync(
    cartId: string | null,
    cart: CartUpdateContract
  ): Promise<SpreedlyPostOrderResponse> {
    if (!cartId) {
      throw InvalidCartIdError;
    }
    try {
      const response = await window.fetch(
        `${this.storeUrl}/api/v1/orders/${cartId ?? ''}`,
        {
          credentials: 'include',
          method: 'POST',
          headers: {
            vMethod: 'POST',
            Accept: 'application/json',
            Connection: 'keep-alive',
            'Content-Type': 'application/json',
            'Keep-Alive': 'timeout=120, max=1000',
          },
          body: JSON.stringify(cart),
        }
      );
      const responseJsonEnvelope = await response.json();
      if (responseJsonEnvelope?.errors?.length) {
        // POSSIBLE FRICTION LOGGING HERE
        throw new ApiValidationError(
          'Order validation failed',
          responseJsonEnvelope.errors
        );
      }

      if (responseJsonEnvelope?.data?.id) {
        return {
          orderId: responseJsonEnvelope.data.id,
          status: responseJsonEnvelope.data.status,
          transactionToken: responseJsonEnvelope.data.transactionToken,
        };
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      if (error?.isValidationError) {
        throw error;
      }
      // eslint-disable-next-line no-console
      console.error(error);
      throw ApiError;
    }
    throw OrderFailedError;
  }
}

export default OrderService;
